import { Link } from 'react-router-dom';

const stats = [
  { value: '6', label: '赛事分类', icon: 'ri-layout-grid-line' },
  { value: '1200+', label: '覆盖赛事', icon: 'ri-calendar-check-line' },
  { value: '300+', label: '黑5专题', icon: 'ri-line-chart-line' },
  { value: '实时', label: '资讯更新', icon: 'ri-flashlight-line' },
];

const highlights = [
  {
    icon: 'ri-database-2-line',
    title: '往期黑5数据统计',
    desc: '按赛事、时间、指标多维归档，支持横向对比与走势回溯，快速定位数据变化。',
  },
  {
    icon: 'ri-line-chart-line',
    title: '深度赛事分析',
    desc: '从进攻效率、控球节奏到关键局表现，用数据拆解比赛走势，辅助理解赛况。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时赛事资讯',
    desc: '焦点战与最新动态按时间倒序排列，重要比赛状态一目了然。',
  },
];

export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="bg-primary-900 rounded-lg px-5 md:px-10 py-8 md:py-12 relative overflow-hidden">
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-accent-500/15" />
        <div className="absolute -left-20 -bottom-20 w-72 h-72 rounded-full bg-secondary-500/10" />
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-block text-xs font-medium tracking-widest text-accent-400 uppercase mb-2">
              About Platform
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
              51每日大赛 · 今日大赛聚集地
            </h2>
            <p className="mt-4 text-sm md:text-base text-primary-200 leading-relaxed">
              我们是一个聚焦综合赛事资讯与数据分析的信息平台，汇聚足球、篮球、电竞、网球等主流项目，
              为体育爱好者、赛事分析人员与普通观众提供清晰、可读、可回溯的赛事信息与黑5数据解读。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {stats.map((item) => (
                <div key={item.label} className="bg-primary-800/70 rounded-md p-3 md:p-4">
                  <i className={`${item.icon} text-accent-400 w-5 h-5 flex items-center justify-center text-lg`} />
                  <p className="mt-2 font-heading text-lg md:text-xl font-semibold text-background-50">
                    {item.value}
                  </p>
                  <p className="text-[11px] md:text-xs text-primary-300">{item.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              了解平台详情
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
            </Link>
          </div>

          <div className="flex flex-col gap-3">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 bg-primary-800/50 rounded-lg p-4 md:p-5"
              >
                <span className="w-10 h-10 rounded-md bg-accent-500 text-background-50 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`} />
                </span>
                <div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-background-50">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-primary-200 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}